// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/possibilities/v1/possibilities.proto (package gdx.gateway.web.possibilities.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * Enumerates possibilities types.
 *
 * @generated from enum gdx.gateway.web.possibilities.v1.PossibilityType
 */
export enum PossibilityType {
  /**
   * @generated from enum value: POSSIBILITY_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: POSSIBILITY_TYPE_FREE_GIFT = 1;
   */
  FREE_GIFT = 1,

  /**
   * @generated from enum value: POSSIBILITY_TYPE_TOP_PROFILE_COMMON = 2;
   */
  TOP_PROFILE_COMMON = 2,

  /**
   * @generated from enum value: POSSIBILITY_TYPE_TOP_PROFILE_PLUS = 3;
   */
  TOP_PROFILE_PLUS = 3,

  /**
   * @generated from enum value: POSSIBILITY_TYPE_ASTROLOGY_CHECK = 4;
   */
  ASTROLOGY_CHECK = 4,

  /**
   * @generated from enum value: POSSIBILITY_TYPE_POWER_LIKE = 5;
   */
  POWER_LIKE = 5,

  /**
   * @generated from enum value: POSSIBILITY_TYPE_SEXUAL_CHECK = 6;
   */
  SEXUAL_CHECK = 6,

  /**
   * @generated from enum value: POSSIBILITY_TYPE_POWER_DONATION = 7;
   */
  POWER_DONATION = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(PossibilityType)
proto3.util.setEnumType(PossibilityType, "gdx.gateway.web.possibilities.v1.PossibilityType", [
  { no: 0, name: "POSSIBILITY_TYPE_INVALID" },
  { no: 1, name: "POSSIBILITY_TYPE_FREE_GIFT" },
  { no: 2, name: "POSSIBILITY_TYPE_TOP_PROFILE_COMMON" },
  { no: 3, name: "POSSIBILITY_TYPE_TOP_PROFILE_PLUS" },
  { no: 4, name: "POSSIBILITY_TYPE_ASTROLOGY_CHECK" },
  { no: 5, name: "POSSIBILITY_TYPE_POWER_LIKE" },
  { no: 6, name: "POSSIBILITY_TYPE_SEXUAL_CHECK" },
  { no: 7, name: "POSSIBILITY_TYPE_POWER_DONATION" },
]);

/**
 * Describes possibility.
 *
 * @generated from message gdx.gateway.web.possibilities.v1.Possibility
 */
export class Possibility extends Message<Possibility> {
  /**
   * @generated from field: gdx.gateway.web.possibilities.v1.PossibilityType type = 1;
   */
  type = PossibilityType.INVALID;

  /**
   * @generated from field: int32 count = 2;
   */
  count = 0;

  constructor(data?: PartialMessage<Possibility>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.possibilities.v1.Possibility";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(PossibilityType) },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Possibility {
    return new Possibility().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Possibility {
    return new Possibility().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Possibility {
    return new Possibility().fromJsonString(jsonString, options);
  }

  static equals(a: Possibility | PlainMessage<Possibility> | undefined, b: Possibility | PlainMessage<Possibility> | undefined): boolean {
    return proto3.util.equals(Possibility, a, b);
  }
}

/**
 * Describes package.
 *
 * @generated from message gdx.gateway.web.possibilities.v1.Package
 */
export class Package extends Message<Package> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: uint32 price_credits = 4;
   */
  priceCredits = 0;

  /**
   * @generated from field: repeated gdx.gateway.web.possibilities.v1.Possibility possibility = 5;
   */
  possibility: Possibility[] = [];

  constructor(data?: PartialMessage<Package>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.possibilities.v1.Package";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "price_credits", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "possibility", kind: "message", T: Possibility, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Package {
    return new Package().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Package {
    return new Package().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Package {
    return new Package().fromJsonString(jsonString, options);
  }

  static equals(a: Package | PlainMessage<Package> | undefined, b: Package | PlainMessage<Package> | undefined): boolean {
    return proto3.util.equals(Package, a, b);
  }
}

/**
 * Describes purchase.
 *
 * @generated from message gdx.gateway.web.possibilities.v1.Purchase
 */
export class Purchase extends Message<Purchase> {
  /**
   * @generated from field: string package_id = 1;
   */
  packageId = "";

  constructor(data?: PartialMessage<Purchase>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.possibilities.v1.Purchase";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "package_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Purchase {
    return new Purchase().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Purchase {
    return new Purchase().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Purchase {
    return new Purchase().fromJsonString(jsonString, options);
  }

  static equals(a: Purchase | PlainMessage<Purchase> | undefined, b: Purchase | PlainMessage<Purchase> | undefined): boolean {
    return proto3.util.equals(Purchase, a, b);
  }
}

